/**
 * A failure message for a form or row action, announced to screen readers.
 * Renders nothing for a null message, so callers can pass mutation state.
 *
 * Not ui/fieldset's ErrorMessage: that is a Headless Description and needs a
 * Field or Dialog ancestor, which the tab-level callers do not have.
 */
export const FormError = ({
  message,
  className
}: {
  message?: string | null;
  className?: string;
}) =>
  message ? (
    <p role="alert" className={className ?? 'text-sm text-red-600 dark:text-red-400'}>
      {message}
    </p>
  ) : null;
